import { render, staticRenderFns } from "./ItemMaster.vue?vue&type=template&id=17319c2c&scoped=true"
import script from "./ItemMaster.vue?vue&type=script&lang=js"
export * from "./ItemMaster.vue?vue&type=script&lang=js"
import style0 from "./ItemMaster.vue?vue&type=style&index=0&id=17319c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17319c2c",
  null
  
)

export default component.exports